export default __webpack_public_path__ + "static/media/solution-en-ligne-min.3e5ac7da.jpg";